var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import scrollIntoView from "scroll-into-view-if-needed";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import Button from "@irati/ui/src/Button";
import FormattedMessage from "@irati/utils/lang";
import { deleteCompanyNewsRow } from "@irati/homepage/services/homepage";
import tracking from "@irati-tracking/homepage";
import history from "@irati/utils/history";
import ContentColumns from "./Content/ContentColumns";
import Empty from "./Empty";
import NewRowModal from "./NewRow/Modal";
import Title from "./Title";
import { DeleteRowButton, RowButtonWrapper } from "./styled";
import { HomePageView } from "../types";
import HomePageRow from "../HomePageRow";
import { isRowEmpty } from "./utils/isRowEmpty";
import companyNewsToRows from "./utils/companyNewsToRows";
var HomepageTiles = /** @class */ (function (_super) {
    __extends(HomepageTiles, _super);
    function HomepageTiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.openModal = function () {
            tracking.homePageCreateRowModal();
            var companyNews = _this.props.companyNews;
            var rows = companyNewsToRows(companyNews);
            _this.setState({
                newRowId: rows.length
            });
        };
        _this.closeModal = function () { return _this.setState({ newRowId: undefined }); };
        _this.removeRow = function (tilesToDelete) {
            var uuid = _this.props.auth.business.uuid;
            var variables = {
                tenantId: uuid,
                tiles: tilesToDelete
            };
            _this.setState({ load: true });
            deleteCompanyNewsRow(variables).then(function () {
                tracking.homePageRemoveRow();
                _this.setState({ load: false });
            });
        };
        _this.onExitEdit = function () {
            history.push("/home");
        };
        return _this;
    }
    HomepageTiles.prototype.componentDidMount = function () {
        scrollIntoView(document.getElementById(this.props.id), {
            scrollMode: "if-needed",
            behavior: "smooth"
        });
        if (this.props.openModal) {
            this.openModal();
        }
    };
    HomepageTiles.prototype.render = function () {
        var _this = this;
        var _a = this.state, load = _a.load, newRowId = _a.newRowId;
        var _b = this.props, companyNews = _b.companyNews, id = _b.id, pageView = _b.pageView;
        var rows = companyNewsToRows(companyNews);
        var lastRow = rows.length > 0 ? rows[rows.length - 1] : [];
        return (React.createElement(React.Fragment, null,
            React.createElement(HomePageRow, { id: id, isEditRowView: pageView === HomePageView.EDIT_LAYOUT_VIEW },
                React.createElement(Col, { xs: 12 },
                    React.createElement(Title, { isAdmin: true, onExitEdit: this.onExitEdit }),
                    companyNews.length === 0 && React.createElement(Empty, { onClick: this.openModal }),
                    rows.map(function (row, i) { return (React.createElement(ContentColumns, { key: i, pageView: pageView, companyNewsRow: row })); }),
                    pageView === HomePageView.EDIT_CONTENT_VIEW && companyNews.length > 0 && (React.createElement(RowButtonWrapper, null,
                        isRowEmpty(lastRow) && (React.createElement(DeleteRowButton, { disabled: load, onClick: function () { return _this.removeRow(lastRow); } },
                            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.deleteRow.button" }))),
                        React.createElement(Button, { disabled: load, primary: true, onClick: this.openModal },
                            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newRow.button" })))))),
            newRowId !== undefined && React.createElement(NewRowModal, { onClose: this.closeModal, onRemoveRow: this.removeRow, rowInt: newRowId })));
    };
    return HomepageTiles;
}(Component));
export default withAuth(HomepageTiles);
